if (!customElements.get("size-guide-display")) {
  // Product accordion
  customElements.define(
    "size-guide-display",
    class SizeGuideDisplay extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        var sg_template = document.querySelector(".size-guide-template");

        if (this.hasAttribute("client-side")) {
          var product_tags_string = this.dataset.prodTags;

          var product_tags = product_tags_string.split(",");

          if (product_tags.length == 0) return;

          for (let i = 0; i < product_tags.length; i++) {
            const tag = product_tags[i];

            var tag_sg_template = document.querySelector(
              `.size-guide-template[data-tag="${tag}"]`,
            );

            if (tag_sg_template) {
              sg_template = tag_sg_template;
              break;
            }
          }
        }
        if (!sg_template) {
          this.closest(".product__accordion").classList.add("hide");
          return;
        }

        //get innerHTML and append
        const templateContent = sg_template.content;

        // Create a deep clone of the template content
        const clone = templateContent.cloneNode(true);

        // Append the cloned content to the web component
        this.appendChild(clone);
      }
    },
  );
}
if (!customElements.get("size-guide")) {
  customElements.define(
    "size-guide",
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
        //init modal
      }
    },
  );
}
